import { Component, signal, inject, OnInit, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastComponent } from './shared/components/Toast/toast.component';
import { ToastService } from './shared/services/toast.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit {
  protected readonly title = signal('financial-engine');
  private translate = inject(TranslateService);
  private toastService = inject(ToastService);
  @ViewChild(ToastComponent) toastComponent!: ToastComponent;

  ngOnInit() {
    // Configurar idioma por defecto
    this.translate.setDefaultLang('es');

    // Cargar idioma guardado o usar español
    const savedLang = localStorage.getItem('preferred-language') || 'es';
    this.translate.use(savedLang);
  }

  ngAfterViewInit(): void {
    this.toastService.register(this.toastComponent);
  }
}
